export default {"src":"/_next/static/media/firefox-integration-hero.4082f427.svg","height":154,"width":300,"blurWidth":0,"blurHeight":0};